import apiClient from './apiClient';

/**
 * Obtiene todas las categorías del servidor
 * @param {boolean} forceRefresh - Si es true, ignora el caché
 * @returns {Promise<Array>} Lista de categorías
 */
async function getCategories() {
  try {
    const response = await apiClient.get('/categories/');
    return response.data;
  } catch (error) {
    console.error('Error al cargar categorías:', error);
    throw error;
  }
}

async function getCategoriesHierarchical() {
  try {
    const response = await apiClient.get('/categories/hierarchical/');
    console.log('Raw hierarchical response:', response.data);
    
    // Make sure we have the correct structure (sanity check)
    if (Array.isArray(response.data)) {
      // Ensure each category has at least an empty children array
      return response.data.map(category => ({
        ...category,
        children: category.children || [] 
      }));
    }
    
    return response.data;
  } catch (error) {
    console.error('Error al cargar categorías:', error);
    throw error;
  }
}

/**
 * Facetas del catálogo: todas las marcas y árbol padre → subcategorías → marcas con conteos.
 */
async function getCatalogFacets() {
  const response = await apiClient.get('/products/filter-facets/');
  return response.data;
}

export {
  getCategories,
  getCategoriesHierarchical,
  getCatalogFacets
};